<div class="relative bg-primary min-h-full lg:min-h-fit lg:h-72 py-10">
    <!--    Navigation Links-->
    <div class="grid lg:grid-cols-7 text-center text-white text-xl font-medium w-11/12 mx-auto">
        @for (link of links; track link; let i = $index) {
            <nav class="pt-5">
                <app-text [value]="link.title"/>
                @if (i !== 1) {
                    <div class="{{link.class}} text-base font-medium pt-3 lg:pt-8">
                        <app-link class="hover:underline" [link]="link"/>
                    </div>
                } @else {
                    <div class="text-white text-base font-medium pt-3 lg:pt-8 lg:grid lg:grid-cols-2">
                        @for (link of shopLinks; track link) {
                            <div [class]="'pt-1'">
                                <app-link class="hover:underline" [link]="link"/>
                            </div>
                        }
                    </div>
                }
            </nav>
        }
        <div class="pt-5">
            <app-text class="uppercase" value="СЛЕДИ Нè"/>
            <!-- Social Media Icons -->
            <div class="flex pt-3 lg:pt-8 justify-center relative">
                @for (iconLink of iconLinks; track iconLink) {
                    <app-primary-button class="icon-on-hover fill-white"
                                        [icon]="iconLink.icon"
                                        [tooltip]="iconLink.name"
                                        (click)="openExternalLink(iconLink.link)"></app-primary-button>
                }
            </div>
            <!-- A phone number in the footer is one of the first things people check on an unknown shop. -->
            <div class="pt-4 text-base font-medium space-y-1">
                <a class="block hover:underline" href="tel:+38973857133">073/857-133</a>
                <a class="block hover:underline" href="viber://chat?number=%2B38973857133">Пиши ни на Viber</a>
            </div>
        </div>
    </div>
    <div class="pt-8 px-3 lg:pt-0 lg:absolute lg:bottom-2 lg:left-0 lg:right-0 text-center text-sm text-gray-100 font-extralight">
        <a class="hover:underline" routerLink="/vrakjanje-i-reklamacii">Враќање и рекламации</a>
        <span class="mx-2" aria-hidden="true">·</span>
        <a class="hover:underline" routerLink="/politika-za-privatnost">Политика за приватност</a>
        <span class="mx-2" aria-hidden="true">·</span>
        <span>© {{ year }} aloeveragel.mk</span>
    </div>
</div>
